





















import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { ComponentsConfig, EmpathizeLayout, EmpathizeLayoutItem, EmpathizeLayoutState } from '../../models';
import { GETTERS_KEYS, SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';
import { EMPATHIZE_GETTERS_KEYS } from '../../store/empathize/empathize.const';
import { VueCssClasses } from '../../utils';
import { SmartComponentMixin } from '../mixins/smart-component.mixin';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.history, ['queryHistoryEnabled']),
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config
    }),
    ...mapGetters(SUBMODULES_PATHS.empathize, {
      layout: EMPATHIZE_GETTERS_KEYS.layout,
      highlightedEmpathizeItem: EMPATHIZE_GETTERS_KEYS.highlightedEmpathizeItem,
      empathizeDetectedState: EMPATHIZE_GETTERS_KEYS.empathizeDetectedState,
      open: EMPATHIZE_GETTERS_KEYS.showOpen
    })
  },
  mixins: [SmartComponentMixin('Empathize')]
})
export default class Empathize extends Vue {
  components: ComponentsConfig;
  queryHistoryEnabled: boolean;
  layout: EmpathizeLayout;
  empathizeDetectedState: EmpathizeLayoutState;

  get nonEmptyLayoutItemsCount() {
    return this.layout.reduce((nonEmptyBlocksCount: number, layoutRow) =>
        layoutRow.reduce((nonEmptyBlocksCountInRow, layoutItem) => {
          const layoutItemData = this.$store.getters[layoutItem.getter];
          if (layoutItem.showWhenEmpty || layoutItemData.length || this.isHistoryAndDisabled(layoutItem)) {
            return ++nonEmptyBlocksCountInRow;
          }
          return nonEmptyBlocksCountInRow;
        }, nonEmptyBlocksCount)
      , 0);
  }

  get cssClasses(): VueCssClasses {
    return [
      `ebx-empathize-panel--${ this.nonEmptyLayoutItemsCount }-layout-items`,
      `ebx-empathize-panel--${ this.empathizeDetectedState }`
    ];
  }

  isHistoryAndDisabled(layoutItem: EmpathizeLayoutItem) {
    return layoutItem.getter === GETTERS_KEYS.history.queryHistory && !this.queryHistoryEnabled;
  }
}
